import { Component, Inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { applyPageSeo, resolvePageUrl } from '../../../../shared/seo/page-seo';

type Tabs = 'AllAssets' | '3DIllustrations' | 'LottieAnimations' | 'Illustrations' | 'IllustrationsKits' | 'Icons';

const CONTRIBUTORS_LIST_PATH = '/contributors-list';
const CONTRIBUTORS_LIST_TITLE = 'Contributors | CreativeStall.com';
const CONTRIBUTORS_LIST_DESCRIPTION =
  'Browse contributors and explore creative assets shared on Creative Stall.';

@Component({
  selector: 'app-contributor',
  standalone: false,
  templateUrl: './contributor.component.html',
  styleUrl: './contributor.component.css',
})
export class ContributorComponent implements OnInit {
  activeTab: Tabs = 'AllAssets';
  contributors = [
    {
      link: '/contributor-profile-id',
      items: [
        { img: 'assets/theme/icons/1.svg' },
        { img: 'assets/theme/icons/2.svg' },
        { img: 'assets/theme/icons/3.svg' },
        { img: 'assets/theme/icons/2.svg' },
      ],
    },
  ];

  constructor(
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    applyPageSeo(
      {
        title: this.titleService,
        meta: this.metaService,
        document: this.document,
      },
      {
        pagePath: CONTRIBUTORS_LIST_PATH,
        pageTitle: CONTRIBUTORS_LIST_TITLE,
        pageDescription: CONTRIBUTORS_LIST_DESCRIPTION,
        pageUrl: resolvePageUrl(CONTRIBUTORS_LIST_PATH, undefined, this.document),
      }
    );
  }

  setTab(tab: Tabs) {
    this.activeTab = tab;
  }

  activeClass(tab: Tabs) {
    return tab === this.activeTab ? 'text-themeBlackTwo border-b-2 border-themeBlackTwo' : '';
  }
}
